import React from "react";
import ArrowIcon from "../../../assets/svg/icons/common/arrow";
import Pagination from "../../../components/Pagination/Pagination";
import useCommonStore from "../../../stores/common";
import styles from "../Application.module.scss";
import ActionBar from "./ActionBar/ActionBar";
import ApplicationRow from "./ApplicationRow";
import useApplicationStore from "../../../stores/application";
import Checkbox from "../../../components/Checkbox/Index";

function ApplicationListing({ fetchList }) {
  const showDetails = useCommonStore((state) => state.showDetails);
  const selectedApps = useApplicationStore((state) => state.selectedApps);
  const setSelectedApps = useApplicationStore((state) => state.setSelectedApps);
  const preapps = useApplicationStore((state) => state.preapps);
  const appFilterSearchQuery = useApplicationStore(
    (state) => state.appFilterSearchQuery,
  );
  const setAppFilterSearchQuery = useApplicationStore(
    (state) => state.setAppFilterSearchQuery,
  );
  const pageCount = useApplicationStore((state) => state.pageCount);
  const totalItems = useApplicationStore((state) => state.totalItems);
  const itemsPerPage = useApplicationStore((state) => state.itemsPerPage);

  const onSortClick = (field) => {
    setAppFilterSearchQuery({
      sortBy: field,
      sortValue: appFilterSearchQuery.sortValue == "DESC" ? "ASC" : "DESC",
    });
  };

  const onAllAppsSelected = (event) => {
    const allIds = preapps.map((preapp) => preapp.id);
    if (event.target.checked) {
      setSelectedApps(allIds);
    } else {
      setSelectedApps([]);
    }
  };

  return (
    <>
      <table>
        <thead>
          <tr>
            <th>
              <Checkbox
                checked={
                  selectedApps.length > 0 &&
                  selectedApps.length == preapps.length
                }
                onChange={onAllAppsSelected}
              />
            </th>
            <th onClick={() => onSortClick("field_dba")}>
              DBA
              {appFilterSearchQuery.sortBy == "field_dba" && (
                <button
                  className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                >
                  <ArrowIcon />
                </button>
              )}
            </th>
            <th onClick={() => onSortClick("progression_id")}>
              STATUS
              {appFilterSearchQuery.sortBy == "progression_id" && (
                <button
                  className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                >
                  <ArrowIcon />
                </button>
              )}
            </th>
            {!showDetails && (
              <th onClick={() => onSortClick("id")}>
                ID
                {appFilterSearchQuery.sortBy == "id" && (
                  <button
                    className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                  >
                    <ArrowIcon />
                  </button>
                )}
              </th>
            )}
            <th>ORGANIZATION</th>
            {!showDetails && (
              <>
                <th>MONTHLY VOLUME</th>
                <th onClick={() => onSortClick("created_at")}>
                  CREATED
                  {appFilterSearchQuery.sortBy == "created_at" && (
                    <button
                      className={`${styles.sorting_button} ${appFilterSearchQuery.sortValue == "DESC" ? "" : styles.asc}`}
                    >
                      <ArrowIcon />
                    </button>
                  )}
                </th>
              </>
            )}
            {/* TODO: Add alerts column will do later */}
            {/* <th>ALERTS</th> */}
            {!showDetails && <th></th>}
          </tr>
        </thead>
        <tbody>
          {preapps.map((preapp) => (
            <ApplicationRow key={preapp.id} app={preapp} fetchList={fetchList} />
          ))}
        </tbody>
      </table>

      {preapps?.length < 1 && (
        <h6 className={styles.no_data_found}>No data found</h6>
      )}

      {preapps?.length > 0 && (
        <div className={styles.pagination_container}>
          <Pagination
            pageCount={pageCount}
            currentPage={appFilterSearchQuery.page - 1}
            onPageChange={({ selected }) => {
              setAppFilterSearchQuery({
                page: selected + 1,
              });
              setSelectedApps([]);
            }}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
          />
        </div>
      )}

      {selectedApps.length > 0 && (
        <ActionBar
          selectedApps={selectedApps}
          close={() => {
            setSelectedApps([]);
          }}
          fetchList={fetchList}
        />
      )}
    </>
  );
}

export default ApplicationListing;
